import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1400,
  parentId: 1000,
  name: "Contact",
  label: "Contact",
  path: "contact",
  element: Element,
  footer: true,
  admin: false,
};

export default route;
